import { Observable } from "rxjs";

import type { ProductIdProviderInterface } from "./ProductIdProviderInterface";

export class ProductIdFromAdditionalInfoProvider
    implements ProductIdProviderInterface
{
    constructor(private readonly additionalInfoData: unknown) {}

    public selectProductId() {
        return new Observable<number | null>((subscriber) => {
            subscriber.next(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                ((this.additionalInfoData as any)["GW_PRODUCT_INFO"]?.[
                    "productId"
                ] as number | null) || null
            );
        });
    }
}
